export const API_BASE = import.meta.env.VITE_API_URL || `http://${window.location.hostname}:7070`;

export const s = {
  main: { maxWidth: 1100, margin: '0 auto', padding: '1.5rem 1rem' },
  pageTitle: { fontSize: '1.4rem', fontWeight: 700, color: '#F8FAFC', marginBottom: '1.25rem' },
  card: { background: '#1E293B', borderRadius: 12, padding: '1.25rem', border: '1px solid #334155', marginBottom: '1rem' },
  cardTitle: { fontWeight: 700, fontSize: '0.85rem', color: '#94A3B8', marginBottom: '0.75rem', textTransform: 'uppercase', letterSpacing: '0.05em' },
  grid: { display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))', gap: '1rem', marginBottom: '1rem' },
  statusRow: { display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '0.5rem 0', borderBottom: '1px solid #334155' },
  statusLabel: { fontSize: '0.9rem', color: '#CBD5E1' },
  statusDot: (up) => ({
    width: 10, height: 10, borderRadius: '50%',
    background: up ? '#10B981' : '#EF4444',
    display: 'inline-block', marginRight: 6,
    boxShadow: up ? '0 0 8px rgba(16,185,129,0.5)' : '0 0 8px rgba(239,68,68,0.5)',
  }),
  statusBadge: (up) => ({
    padding: '2px 10px', borderRadius: 12, fontSize: '0.75rem', fontWeight: 700,
    background: up ? 'rgba(16,185,129,0.15)' : 'rgba(239,68,68,0.15)',
    color: up ? '#10B981' : '#EF4444',
  }),
  metricBig: { fontSize: '2.5rem', fontWeight: 800, color: '#F8FAFC', lineHeight: 1 },
  metricLabel: { fontSize: '0.8rem', color: '#64748B', marginTop: 4 },
  metricUnit: { fontSize: '1rem', fontWeight: 400, color: '#64748B' },
  progressBar: { width: '100%', height: 8, borderRadius: 4, background: '#334155', marginTop: 8 },
  progressFill: (pct) => ({
    width: `${Math.min(pct, 100)}%`, height: '100%', borderRadius: 4,
    background: pct > 80 ? '#EF4444' : pct > 60 ? '#F59E0B' : '#10B981',
    transition: 'width 0.5s ease',
  }),
  detail: { fontSize: '0.8rem', color: '#64748B', marginTop: 4 },
  filterBar: {
    display: 'flex', flexWrap: 'wrap', gap: '0.75rem', alignItems: 'flex-end',
    marginBottom: '1rem', padding: '1rem', background: '#1E293B', borderRadius: 10,
    border: '1px solid #334155',
  },
  filterGroup: { display: 'flex', flexDirection: 'column', gap: '0.25rem' },
  filterLabel: { fontSize: '0.7rem', color: '#94A3B8', fontWeight: 600, textTransform: 'uppercase', letterSpacing: '0.04em' },
  filterInput: {
    padding: '0.45rem 0.6rem', borderRadius: 6, border: '1px solid #475569',
    background: '#0F172A', color: '#F8FAFC', fontSize: '0.85rem', outline: 'none',
  },
  filterSelect: {
    padding: '0.45rem 0.6rem', borderRadius: 6, border: '1px solid #475569',
    background: '#0F172A', color: '#F8FAFC', fontSize: '0.85rem', outline: 'none',
    minWidth: 160,
  },
  primaryBtn: {
    padding: '0.5rem 1rem', borderRadius: 6, border: 'none', cursor: 'pointer',
    fontSize: '0.85rem', fontWeight: 600,
    background: 'linear-gradient(135deg, #7C3AED, #06B6D4)', color: '#fff',
  },
  outlineBtn: {
    padding: '0.5rem 1rem', borderRadius: 6, border: '1px solid #475569',
    background: 'transparent', cursor: 'pointer', fontSize: '0.85rem', color: '#94A3B8',
  },
  freezeBtn: (frozen) => ({
    padding: '4px 12px', borderRadius: 6, border: 'none', cursor: 'pointer',
    fontSize: '0.75rem', fontWeight: 600,
    background: frozen ? 'rgba(16,185,129,0.15)' : 'rgba(239,68,68,0.15)',
    color: frozen ? '#10B981' : '#EF4444',
  }),
  frozenBadge: {
    padding: '2px 10px', borderRadius: 12, fontSize: '0.75rem', fontWeight: 700,
    background: 'rgba(239,68,68,0.15)', color: '#EF4444',
  },
};

export function authHeaders(token) {
  return { Authorization: `Bearer ${token}` };
}

export function formatRelativeDate(iso) {
  if (!iso) return '';
  const now = new Date();
  const date = new Date(iso);
  const diffDays = Math.floor((now - date) / (1000 * 60 * 60 * 24));
  if (diffDays < 1) return 'today';
  if (diffDays === 1) return '1 day ago';
  if (diffDays < 30) return `${diffDays} days ago`;
  const m = Math.floor(diffDays / 30);
  if (m === 1) return '1 month ago';
  if (m < 12) return `${m} months ago`;
  const y = Math.floor(m / 12);
  return y === 1 ? '1 year ago' : `${y} years ago`;
}

export function fmtTime(iso) {
  if (!iso) return '\u2014';
  return new Date(iso).toLocaleString(undefined, { month: 'short', day: 'numeric', hour: '2-digit', minute: '2-digit' });
}

export function parseDevice(ua) {
  if (!ua) return '\u2014';
  if (ua.includes('Mobile')) return 'Mobile';
  if (ua.includes('Chrome')) return 'Chrome';
  if (ua.includes('Firefox')) return 'Firefox';
  if (ua.includes('Safari')) return 'Safari';
  if (ua.includes('Edge')) return 'Edge';
  return ua.substring(0, 30);
}
